export default "__VITE_ASSET__BELpS$bO__"